import type { IconData } from '@stacksjs/iconify-core'

export const tableRightHeader: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M10 2H2v10h8zm2-2a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export default tableRightHeader
